var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsStarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 212,
    viewBox: "0 0 332 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9822 68L52.4478 75.5885L60.4269 75.5885L53.9717 80.2785L56.4374 87.867L49.9822 83.177L43.527 87.867L45.9927 80.2785L39.5375 75.5885L47.5165 75.5885L49.9822 68Z",
    fill: "#D59F55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.982 65L261.448 72.5885L269.427 72.5885L262.972 77.2785L265.437 84.867L258.982 80.177L252.527 84.867L254.993 77.2785L248.538 72.5885L256.517 72.5885L258.982 65Z",
    fill: "#D59F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.595 0L157.061 7.58851L165.04 7.58851L158.585 12.2785L161.051 19.867L154.595 15.177L148.14 19.867L150.606 12.2785L144.151 7.58851L152.13 7.58851L154.595 0Z",
    fill: "#D59F55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9822 156L30.4478 163.589L38.4269 163.589L31.9717 168.278L34.4374 175.867L27.9822 171.177L21.527 175.867L23.9927 168.278L17.5375 163.589L25.5165 163.589L27.9822 156Z",
    fill: "#D59F55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.982 150L294.448 157.589L302.427 157.589L295.972 162.278L298.437 169.867L291.982 165.177L285.527 169.867L287.993 162.278L281.538 157.589L289.517 157.589L291.982 150Z",
    fill: "#D59F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsStarts);
export default __webpack_public_path__ + "static/media/contact-us-starts.e2b8bd0b5f4a6ab0236d16373a8635e1.svg";
export { ForwardRef as ReactComponent };